import React, { useState } from "react";
import { Image, Button, Icon, Table, Modal, Popup } from "semantic-ui-react";
import { image } from "../../../../assets";
import { Company } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal, ConfirmModal } from "../../../Shared";
import { ENV } from "../../../../utils";
import { CompanyForm } from "../CompanyForm";
import "./CompanyItem.scss";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts";

const companyController = new Company();

export function CompanyItem(props) {
  const { company, onReload, permissionsByRole } = props;
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [modalOpen, setModalOpen] = useState(false); // Estado para abrir/cerrar el modal
  const [contentModal, setContentModal] = useState("");


  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateCompany = () => {
    setTitleModal(`${t("update")} ${company.name}`);
    onOpenCloseModal();
  };

  const openDesactivateActivateConfim = () => {
    setIsDelete(false);
    setConfirmMessage(
      company.active
        ? `${t("deactivate")} empresa "${company.name}"`
        : `${t("activate")} empresa "${company.name}"`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await companyController.updateCompany(accessToken, company._id, {
        active: !company.active,
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmMessage(`¿${t("question_delete")} "${company.name}"?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      const response = await companyController.deleteCompany(accessToken, company._id);
      onReload();
      onOpenCloseConfirm();
      // No se pudo avisar a la otra app Sustemia: el master tiene que saberlo.
      if (response?.integrationWarning) {
        setContentModal(response.integrationWarning);
        setModalOpen(true);
      }
    } catch (error) {
      console.error(error);
      setContentModal(error.msg);
      setModalOpen(true);
      onOpenCloseConfirm();
    }
  };
  // Manejador de cierre del modal
  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Table.Row key={company._id}>
        <Table.Cell>{company.name ? company.name : ""}</Table.Cell>
         <Table.Cell>{company.cuit}</Table.Cell>
          <Table.Cell>{company.phone}</Table.Cell>
        <Table.Cell>{company.email}</Table.Cell>
        <Table.Cell>
          {isMaster(role) ||
          hasPermission(permissionsByRole, role._id, "companies", "edit") ? (
             <Popup
               content={t("edit")}
               trigger={
                 <Button icon primary onClick={openUpdateCompany}>
                   <Icon name="pencil" />
                 </Button>
               }
             />
          ) : null}
          {isMaster(role) ||
          hasPermission(permissionsByRole, role._id, "companies", "edit") ? (
             <Popup
               content={company.active ? t("deactivate") : t("activate")}
               trigger={
                 <Button
                   icon
                   color={company.active ? "orange" : "teal"}
                   onClick={openDesactivateActivateConfim}
                 >
                   <Icon name={company.active ? "ban" : "check"} />
                 </Button>
               }
             />
          ) : null}
          {/* Borrar empresas: solo master (el servidor lo exige). */}
          {isMaster(role) ? (
            <Popup
    content={t("delete")}
    trigger={
      <Button icon color="red" onClick={openDeleteConfirm}>
        <Icon name="trash" />
      </Button>
    }
  />
          ) : null}
        </Table.Cell>
      </Table.Row>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal} size={"small"}>
        <CompanyForm
          close={onOpenCloseModal}
          onReload={onReload}
          company={company}
        />
      </BasicModal>

      <ConfirmModal
        open={showConfirm}
        title={isDelete ? t("delete") : t("activate_deactivate")}
        content={confirmMessage}
        onConfirm={isDelete ? onDelete : onActivateDesactivate}
        onCancel={onOpenCloseConfirm}
        danger={isDelete}
      />

      

      {/* Modal de advertencia si no hay datos */}
      <Modal open={modalOpen} onClose={closeModal} size="tiny">
        <Modal.Header>
          <Icon name="warning sign" /> Advertencia
        </Modal.Header>
        <Modal.Content>
          <p>{contentModal}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={closeModal}>Cerrar</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}
